import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../services/axios";
import {
  Box,
  Flex,
  Spinner,
} from "@chakra-ui/react";
import { useMusicPlayer } from "../../context/MusicPlayerContext";
import { useCart } from "../../context/CartContext";
import DailyStreamChart from "../Charts/DailyStreamChart";
import TrackOverview from "../Track/TrackOverview";

const Track = () => {
  const { trackId } = useParams();
  const [trackInfo, setTrackInfo] = useState(null);
  const [trackLoading, setTrackLoading] = useState(true);

  const { playTrack, isPlaying, currentTrack } = useMusicPlayer();
  const { addToCart } = useCart();

  useEffect(() => {
    const fetchTrackInfo = async () => {
      try {
        setTrackLoading(true);
        const response = await axiosInstance.post(
          `/music/get_track_by_id/${trackId}`
        );
        setTrackInfo(response.data);
      } catch (error) {
        console.error("Error fetching track info:", error);
      } finally {
        setTrackLoading(false);
      }
    };
    fetchTrackInfo();
  }, [trackId]);

  if (trackLoading) {
    return (
      <Flex h="60vh" align="center" justify="center">
        <Spinner size="xl" color="secondary.500" />
      </Flex>
    );
  }

  if (!trackInfo) {
    return (
      <Flex h="60vh" align="center" justify="center">
        <Spinner size="xl" color="secondary.900" />
      </Flex>
    );
  }

  return (
    <Box px={{ base: 2, sm: 2 }} py={6}>
      {/* Track Overview */}
      <TrackOverview trackInfo={trackInfo} />
      
      {/* Daily Stream Chart */}
      <Box mt={8}>
        <DailyStreamChart trackInfo={trackInfo} />
      </Box>
    </Box>
  );
};

export default Track;